import styled from 'styled-components';

import { BannerSize } from './Banner.types';

type StyledBannerLinkProps = {
   href: string | undefined;
   $size: BannerSize;
};

const bannerSizeMap: Record<BannerSize, { height: string; width: string }> = {
   DEFAULT: {
      height: '292px',
      width: '360px',
   },
   BIG: {
      height: '412px',
      width: '508px',
   },
} as const;

export const StyledBannerLink = styled.a<StyledBannerLinkProps>`
   display: block;
   position: relative;
   height: ${({ $size }) => bannerSizeMap[$size].height};
   width: ${({ $size }) => bannerSizeMap[$size].width};
   overflow: hidden;
   border-radius: 20px;
   cursor: ${({ href }) => (href ? 'pointer' : 'default')};
   flex: 0 0 auto;
`;
StyledBannerLink.displayName = 'StyledBannerLink';

export const StyledBannerImage = styled.img`
   position: absolute;
   transform: translateY(-50%);
   top: 50%;
`;
StyledBannerImage.displayName = 'StyledBannerImage';
